import { useState, useCallback, useMemo } from "react";
import useAuth from "./useAuth";
import { useGetFirmQuery } from "../store/storageRoles/firmApi";
import { useGetDealerRolesFirmsQuery } from "../store/dealerRoles/firmApi";

export function useFirmData(token) {
  const { auth } = useAuth();
  const [paginationNumber, setPaginationNumber] = useState(1);
  const [filteredData, setFilteredData] = useState("");
  const [isSearch, setIsSearch] = useState(false);

  const isDealer = auth?.role === "dealer";

  const firmQuery = useGetFirmQuery(
    { token },
    {
      refetchOnMountOrArgChange: true,
      skip: !!isDealer,
    }
  );

  const dealerQuery = useGetDealerRolesFirmsQuery(
    { token },
    {
      refetchOnMountOrArgChange: true,
      skip: !isDealer || !token,
    }
  );

  const firmData = isDealer ? dealerQuery.data : firmQuery.data;
  const isLoading = isDealer ? dealerQuery.isLoading : firmQuery.isLoading;
  const isFetching = isDealer ? dealerQuery.isFetching : firmQuery.isFetching;
  const error = isDealer ? dealerQuery.error : firmQuery.error;
  const refetch = isDealer ? dealerQuery.refetch : firmQuery.refetch;

  const firms = useMemo(() => firmData?.data?.firms || [], [firmData]);

  const handleSearch = useCallback((data, isSearch) => {
    setPaginationNumber(1);
    setFilteredData(data);
    setIsSearch(isSearch);
  }, []);

  return {
    firms,
    isLoading,
    isFetching,
    error,
    refetch,
    paginationNumber,
    setPaginationNumber,
    filteredData,
    isSearch,
    handleSearch,
  };
}
